function setCookie(name: string, value: string, hours: number) {
	const now = new Date()
	const expirationDate = new Date(now.getTime() + hours * 60 * 60 * 1000) // Calculate expiration time
	const expires = `expires=${expirationDate.toUTCString()}`
	document.cookie = `${name}=${value};${expires};path=/` // Set the cookie
}

export default setCookie
